export enum MessageType {
  ERROR = 'error',
  WARNING = 'warning',
  SUCCESS =  'success'
}
